import { format } from 'date-fns';

import { Media, Video } from '@/queries/media/types';

import AnimalIcon from '../AnimalIcon';
import NewTag from '../HighlightsList/NewTag';
import { isNew } from '../HighlightsList/utils';
import VideoLikeButton from './VideoLikeButton';

interface MobileMediaCardProps {
  video: Media | Video;
  isPlaying?: boolean;
}

const MobileMediaCard = ({ video, isPlaying }: MobileMediaCardProps) => {
  const { user, habitat, publishedAt } = video;
  const habitatTitle = habitat?.title;

  return (
    <>
      <div className="preflight relative overflow-hidden rounded desktop:rounded-lg">
        <img className="preflight preflight-img aspect-video" src={video.thumbnailURL} alt={video.title} loading="lazy" />
        {isPlaying && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/75">
            <VideoLikeButton
              mediaId={video._id}
              type={'mediaType' in video && video.mediaType === 'photo' ? 'photo' : 'video'}
              isLiked={video.isLiked}
              likes={video.usersLike}
            />
          </div>
        )}
      </div>
      <div className="flex flex-col justify-center gap-0.5">
        {/* Habitat Name */}
        <span className="text-[12px] font-bold leading-[12px] text-[#7f7c7c]">{habitatTitle || 'zoolife'}</span>

        {/* User Info Row */}
        <div className="mt-1 flex items-center gap-1.5 leading-[12px]">
          {user?.profile?.animalIcon && (
            <AnimalIcon animalIcon={user.profile.animalIcon} color={user.profile.color} width={18} />
          )}

          <span className="text-[10px] font-medium text-black">
            {user?.username ?? 'zoolife'}
            {publishedAt && (
              <span className="font-normal text-black">
                {' '}
                at {format(new Date(publishedAt), 'ha').toLowerCase()} {format(new Date(publishedAt), 'MMM d')}
              </span>
            )}
          </span>
        </div>

        {/* Title & New Tag */}
        <h5 className="preflight preflight-h5 line-clamp-2 text-base font-bold leading-tight text-black">
          {publishedAt && isNew(publishedAt) && <NewTag className="mr-1 inline-block align-middle" />}
          {video.title}
        </h5>
      </div>
    </>
  );
};

export default MobileMediaCard;
